export type TransactionType =
  | 'TRANSACTION_REQUEST_TYPE_NOVA_SALE'
  | 'TRANSACTION_REQUEST_TYPE_WITHDRAWAL'
  | 'TRANSACTION_REQUEST_TYPE_CARD_WITHDRAWAL'
  | 'TRANSACTION_REQUEST_TYPE_DIVIDEND_WITHDRAWAL'
  | 'TRANSACTION_REQUEST_TYPE_DEPOSIT'

export type Deposit = {
  transactionId: string
  isAuto: boolean
  processingProvider: string
  processingMethod: string
  status: string
  initialAmount: string
  initialCurrency: string
  clientAmount: string
  clientCurrency: string
  clientCommission: string
  companyCommission: string
  commissionCurrency: string
  createdAt: string
  updatedAt: string
  humanCreatedAt?: string
  humanUpdatedAt?: string
  client: Client
  clientId: string
  externalTransferId: string
  product: string
  externalTransaction: ExternalTransaction
  externalPaymentTransaction: ExternalPaymentTransaction
  gateway: Gateway
  changeHistory: Manager
  transactionType: TransactionType
}

export type ExternalTransaction = {
  externalId: string
}

export type ExternalPaymentTransaction = {
  externalId: string
}

export type Gateway = {
  internalName: string
}

export type Client = {
  clientId: string
  email: string
  fullName: string
  partner: boolean
  partnerStatus?: string
  country?: string
  isTest: boolean
  isPremium: boolean
}

export type Manager = {
  id: string
  user: User
}

export type User = {
  email: string
  fullName: string
}

export type DepositResponse = {
  items: Deposit[]
  total: number
}

export type DepositRequest = {
  limit: number
  page: number
  orderBy: string
  orderDirection: string
  searchText: { [key: string]: string }
  filters?: {
    status?: string[] | null
    isAuto?: string[] | null
    initialCurrency?: string[] | null
    clientCurrency?: string[] | null
    product?: string[] | null
    transactionType?: string[] | null
  }
}

export enum ETransactionTypes {
  TRANSACTION_REQUEST_TYPE_NOVA_SALE = 'Nova sale',
  TRANSACTION_REQUEST_TYPE_NOVA_DEPOSIT = 'Nova deposit',
  TRANSACTION_REQUEST_TYPE_WITHDRAWAL = 'Withdrawal',
  TRANSACTION_REQUEST_TYPE_DEPOSIT = 'Deposit',
  TRANSACTION_REQUEST_TYPE_CARD_WITHDRAWAL = 'Card withdrawal',
  TRANSACTION_REQUEST_TYPE_DIVIDEND_WITHDRAWAL = 'Dividend withdrawal',
}
